import Demo, { DemoSelectControl } from '@/components/Demo';

import FlexDemo from './FlexDemo';
import Item from './Item';
import Output from './Output';

function AlignSelf() {
  return (
    <FlexDemo
      initialValues={{
        '--direction': 'row',
        firstChildAlignSelf: 'stretch',
        showAxisLabels: false,
      }}
      controls={[
        <DemoSelectControl
          inline
          key="--direction"
          id="--direction"
          label="flex-direction"
          options={['row', 'column']}
        />,
        <DemoSelectControl
          inline
          key="firstChildAlignSelf"
          id="firstChildAlignSelf"
          label="align-self"
          options={[
            'stretch',
            'flex-start',
            'center',
            'flex-end',
            'baseline',
          ]}
          wrapperStyle={{
            color: 'hsl(50deg 100% 65%)',
          }}
          style={{
            color: 'black',
            background: 'hsl(50deg 100% 50%)',
          }}
        />,
      ]}
    >
      {({ firstChildAlignSelf, ...state }) => (
        <Output state={state}>
          <Item
            primary
            style={{
              alignSelf: firstChildAlignSelf,
              fontSize: '1.375rem',
            }}
          >
            Hello
          </Item>
          <Item>to</Item>
          <Item>the</Item>
          <Item style={{ fontSize: '1.375rem' }}>world</Item>
        </Output>
      )}
    </FlexDemo>
  );
}

export default AlignSelf;
